import { render, staticRenderFns } from "./TemplateListPage.vue?vue&type=template&id=08c78036&scoped=true"
import script from "./TemplateListPage.vue?vue&type=script&lang=js"
export * from "./TemplateListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c78036",
  null
  
)

export default component.exports